/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDeskFilled: {
  name: 'desk-filled';
  data: string;
} = {
  name: 'desk-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.643 5.069C2.291 5.193 2 5.614 2 6c0 .396.291.808.66.934.107.036.227.066.267.066.07 0 .073.225.073 6.073 0 6.821-.023 6.306.299 6.628a.984.984 0 0 0 1.402 0c.316-.316.299-.047.299-4.628V11h9v2.573c0 2.904-.008 2.821.299 3.128.301.301.282.299 2.628.299H19v1.073c0 1.235.021 1.35.299 1.628a.984.984 0 0 0 1.402 0c.322-.322.299.193.299-6.628C21 7.225 21.003 7 21.073 7c.173 0 .471-.142.628-.299a.984.984 0 0 0 0-1.402c-.326-.327.567-.299-9.718-.296-8.192.003-9.182.01-9.34.066M19 8v1h-3V7h3zm0 5v1h-3v-2h3z"/></svg>`
};
